import { SelectedGraph } from '../types';

type GetReferenceIdsBetweenStartAndSelectedContextArgs = SelectedGraph & {
  currentContextId: string;
  targetContextId: string;
  referenceIds?: string[];
  visited?: Set<string>;
};

export const getReferenceIdsBetweenStartAndSelectedContext = (
  args: GetReferenceIdsBetweenStartAndSelectedContextArgs
): string[] => {
  const {
    currentContextId,
    targetContextId,
    referenceIds = [],
    visited = new Set(),
    sourceMap,
    targetMap,
  } = args;

  if (currentContextId === targetContextId) return referenceIds;
  const targets = (sourceMap.get(currentContextId) ?? []).filter(
    ({ componentId }) => !visited.has(componentId)
  );
  const sources = (targetMap.get(currentContextId) ?? []).filter(
    ({ componentId }) => !visited.has(componentId)
  );
  const linkedComponents = [...targets, ...sources];
  if (linkedComponents.length === 0) return [];
  linkedComponents.forEach(({ componentId }) => visited.add(componentId));
  return linkedComponents.flatMap(({ referenceId, componentId }) =>
    getReferenceIdsBetweenStartAndSelectedContext({
      ...args,
      currentContextId: componentId,
      referenceIds: [...referenceIds, referenceId],
      visited,
    })
  );
};
